import { Plus, Lock as LockIcon } from 'lucide-react';
import PlanGate from '../../../../components/gating/PlanGate';
import { postTripData } from '../../utils/postTripHelpers';

const PostTripHeader = ({ activeTab, onAddPackage }) => {
    const { title, description } = postTripData.header;

    return (
        <div className="flex flex-col xl:flex-row items-start xl:items-center justify-between gap-4 mb-6 animate-in fade-in duration-200">
            <div className="w-full xl:w-auto">
                <h1 className="text-xl sm:text-2xl font-black text-[#067978] tracking-tight uppercase">
                    {title}
                </h1>
                <p className="text-xs sm:text-sm text-slate-500 mt-1">
                    {description}
                </p>
            </div>

            {/* Dynamic Action Button */}
            <div className="flex items-center gap-3 w-full xl:w-auto flex-1 justify-end">
                {activeTab === 'packages' && onAddPackage && (
                    <PlanGate
                        requiredPlan="pro"
                        featureName="Post Trip Packages"
                        tooltipText="Package creation requires the Pro Plan."
                        showLockIcon={false}
                        wrapperClassName="w-full md:w-auto"
                    >
                        {({ isLocked }) => (
                            <button
                                type="button"
                                onClick={onAddPackage}
                                className="w-full md:w-auto px-6 py-2.5 bg-[#067978] text-white rounded-xl text-sm font-semibold hover:bg-[#056665] shadow-lg shadow-[#067978]/20 transition-all active:scale-95 cursor-pointer flex items-center justify-center gap-2 whitespace-nowrap"
                            >
                                <Plus size={18} />
                                <span>Add Package</span>
                                {isLocked && <LockIcon size={14} className="ml-1 text-white/90 shrink-0" />}
                            </button>
                        )}
                    </PlanGate>
                )}
            </div>
        </div>
    );
};

export default PostTripHeader;
